"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESavePhoneStatus = void 0;
exports.createSavePhoneModel = createSavePhoneModel;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const defaultConfig = {
  apiType: 'legacy',
  assertStatusCodes: [200, 404],
  method: 'POST',
  microserviceName: 'monolithCsharp',
  pathApi: '/api/profile/savephone/',
  hostType: 'api'
};
function createSavePhoneModel(config) {
  return _objectSpread(_objectSpread({}, defaultConfig), config);
}
let ESavePhoneStatus = exports.ESavePhoneStatus = /*#__PURE__*/function (ESavePhoneStatus) {
  ESavePhoneStatus["Success"] = "Success";
  ESavePhoneStatus["ValidationFailed"] = "ValidationFailed";
  ESavePhoneStatus["PhoneAlreadyExists"] = "PhoneAlreadyExists";
  ESavePhoneStatus["InvalidPhone"] = "InvalidPhone";
  return ESavePhoneStatus;
}({});